export default defineNuxtPlugin(() => {
  // 仅在生产环境启用
  if (process.env.NODE_ENV !== 'production') return

  // 禁用右键菜单
  document.addEventListener('contextmenu', (e) => {
    e.preventDefault()
  })

  // 禁用快捷键
  document.addEventListener('keydown', (e) => {
    // F12
    // if (e.key === 'F12') {
    //   e.preventDefault()
    //   return false
    // }

    // Ctrl+Shift+I (开发者工具)
    if (e.ctrlKey && e.shiftKey && e.key === 'I') {
      e.preventDefault()
      return false
    }

    // Ctrl+Shift+J (控制台)
    if (e.ctrlKey && e.shiftKey && e.key === 'J') {
      e.preventDefault()
      return false
    }

    // Ctrl+Shift+C (检查元素)
    if (e.ctrlKey && e.shiftKey && e.key === 'C') {
      e.preventDefault()
      return false
    }

    // Ctrl+U (查看源代码)
    if (e.ctrlKey && e.key === 'u') {
      e.preventDefault()
      return false
    }

    // Cmd+Option+I (Mac 开发者工具)
    if (e.metaKey && e.altKey && e.key === 'i') {
      e.preventDefault()
      return false
    }

    // Cmd+Option+J (Mac 控制台)
    if (e.metaKey && e.altKey && e.key === 'j') {
      e.preventDefault()
      return false
    }

    // Cmd+Option+C (Mac 检查元素)
    if (e.metaKey && e.altKey && e.key === 'c') {
      e.preventDefault()
      return false
    }

    // Cmd+Option+U (Mac 查看源代码)
    if (e.metaKey && e.altKey && e.key === 'u') {
      e.preventDefault()
      return false
    }
  })

  // 检测开发者工具是否打开（通过窗口大小变化检测）
  const threshold = 160
  const detectDevTools = () => {
    const widthThreshold = window.outerWidth - window.innerWidth > threshold
    const heightThreshold = window.outerHeight - window.innerHeight > threshold

    if (widthThreshold || heightThreshold) {
      // 开发者工具可能已打开，可以选择重定向或显示警告
      // window.location.href = 'about:blank'
      console.clear()
    }
  }

  window.addEventListener('resize', detectDevTools)

  // 禁用控制台输出（清空）
  const clearConsole = () => {
    console.clear()
  }

  // 定期清空控制台
  setInterval(clearConsole, 1000)
})
